import React, { useState } from "react";
import { Share2 } from "lucide-react";
import { ShareCardModal } from "@/components/ShareCardModal";

export const NumberOneShareButton = ({ item, greeting, dark = false, testid }) => {
  const [open, setOpen] = useState(false);
  const ddmm = item.date ? `${item.date.slice(8, 10)}-${item.date.slice(5, 7)}` : "";
  const weeks = item.weeks_at_no1 ? ` It spent ${item.weeks_at_no1} week${item.weeks_at_no1 === 1 ? "" : "s"} at the top.` : "";
  return (
    <>
      <button
        type="button"
        data-testid={testid}
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }}
        aria-label="Share this No.1"
        title="Share this No.1"
        className={`w-7 h-7 shrink-0 rounded-full border flex items-center justify-center transition-colors ${dark ? "border-white/20 text-white/60 hover:border-gold hover:text-gold" : "border-[#e5e7eb] bg-white text-ink-muted hover:border-gold hover:text-gold"}`}
      >
        <Share2 className="w-3.5 h-3.5" />
      </button>
      <ShareCardModal
        open={open}
        onClose={() => setOpen(false)}
        heading="Share this No.1"
        analyticsName="number_one_card"
        testPrefix="no1-card"
        shareUrl={`${window.location.origin}/number-ones?q=${encodeURIComponent(item.title)}`}
        card={{
          badge: item.chart_label ? `${item.chart_label} No.1` : "UK No.1 single",
          greeting,
          title: item.title,
          body: `by ${item.artist} — official No.1 on the ${item.chart_label || "UK Singles"} chart on ${item.date_label}.${weeks}`,
          dateLabel: item.date_label,
          footer: `Every UK No.1 since 1952 → oddlytrue.co/number-ones`,
        }}
      />
    </>
  );
};
